import { SvgIcon, SxProps } from '@mui/material';
import React from 'react';
import CopyToClipBoard from '../../form/widgets/CopyToClipBoard';
import { useShallowMergeSxProps } from '../../hooks/useShallowMergeSxProps';
import { H } from '../../Layout';
import { useStyling } from '../../Theme';

const BASE_CONTAINER_SX = {
    fontSize: '12px'
};

const BASE_ICON_SX = {
    color: 'action.active'
};

export default ({
    href,
    icon,
    hoverTitle,
    clipboardContent,
    iconSx = {},
    containerSx = {}
}: {
    href: string;
    icon: typeof SvgIcon;
    hoverTitle: string;
    clipboardContent: string;
    iconSx?: SxProps;
    containerSx?: SxProps;
}) => {
    const { isMobile } = useStyling();
    const mergedContainerSx = useShallowMergeSxProps(BASE_CONTAINER_SX, containerSx);
    const mergedIconSx = useShallowMergeSxProps(BASE_ICON_SX, iconSx);

    return (
        <H gap={1} sx={mergedContainerSx}>
            {isMobile ? (
                <SvgIcon aria-label={`copy ${hoverTitle}`} href={href} component={icon} sx={mergedIconSx} />
            ) : (
                <CopyToClipBoard
                    hoverTitle={hoverTitle}
                    clipboardContent={clipboardContent}
                    renderCustomComponent={(props) => (
                        <SvgIcon aria-label={`copy ${hoverTitle}`} {...props} component={icon} sx={mergedIconSx} />
                    )}
                    sx={mergedIconSx}
                />
            )}
        </H>
    );
};
